<!-- @format -->

<app-payment-failed [requestInProgress]="requestInProgress()" (retryPaymentForCartId)="retryPayment($event)" />
